var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-background"},[_c('div',{ref:"neuralNetwork",attrs:{"id":"neural-network"}})])}
var staticRenderFns = []

export { render, staticRenderFns }